module.exports = __webpack_public_path__ + "static/media/mediation-active.53913fae.svg";